export default {
    id: null,
    name: "",
    description: "",
    is_active: true
}